/* ============================================================
   Loads the whole collection into one grid.

   Shopify caps `paginate` at 50 per page and rejects anything higher at the
   schema level, so the full catalogue can't be server-rendered in one request.
   The Framer shop showed all 179 products at once, so this restores that:
   the first 50 arrive server-rendered and the rest are appended as the
   visitor scrolls — no clicking, and no pagination to step through.

   Pages load on scroll rather than all at once on page load. See the
   IntersectionObserver below for why that matters.

   The button stays in the markup as a real link, so with JavaScript disabled
   it degrades to ordinary pagination and a crawler can still follow it.
   ============================================================ */
(function () {
  'use strict';

  var grid = document.querySelector('.wr-product-grid');
  if (!grid) return;

  var busy = false;

  function load(btn) {
    if (busy || !btn) return;
    busy = true;
    btn.classList.add('is-busy');
    btn.textContent = 'Loading...';

    fetch(btn.href)
      .then(function (r) {
        if (!r.ok) throw new Error('page unavailable');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.wr-product-grid .wr-shop-card');
        Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
        if (window.wrAnnounce && cards.length) {
          window.wrAnnounce(cards.length + ' more products loaded.');
        }

        var nextBtn = doc.querySelector('[data-wr-loadmore]');
        var wrap = btn.closest('.wr-loadmore');
        busy = false;
        btn.classList.remove('is-busy');
        btn.textContent = btn.getAttribute('data-label') || 'Load More';

        if (nextBtn) {
          // Arm the next page rather than fetching it immediately. Re-arm
          // on a short delay: observing an element that is already within
          // rootMargin fires the callback at once, so a visitor parked at
          // the bottom would otherwise pull every remaining page in one
          // burst — the exact traffic shape this change exists to avoid.
          btn.href = nextBtn.getAttribute('href');
          setTimeout(function () { observe(btn); }, 400);
        } else if (wrap) {
          wrap.remove();
        }
      })
      .catch(function () {
        // Leave the link usable so the page still works as pagination.
        busy = false;
        btn.classList.remove('is-busy');
        btn.textContent = btn.getAttribute('data-label') || 'Load More';
      });
  }

  // Manual click still works — and is the only path without
  // IntersectionObserver, or if a fetch fails.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wr-loadmore]');
    if (!btn) return;
    e.preventDefault();
    load(btn);
  });

  /* Fetch the next page when the visitor scrolls near the button, rather
     than pulling the whole collection on page load.

     The earlier version recursed straight through every page the moment
     the grid appeared: four rapid full-page fetches per visit, with no
     user interaction, on every collection and search view. That is a
     scraper's traffic shape, and the Cloudflare layer in front of the
     storefront answers it with a challenge (HTTP 429) applied to
     everything from that visitor's IP — including the add-to-cart fetch,
     which cannot solve a challenge and so simply dies.

     Requests now track real scrolling: a visitor who never reaches the
     bottom costs one page instead of four, and one who does still gets
     the whole collection. rootMargin starts the fetch before the button
     is on screen, so pages usually arrive before they are reached. */
  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          load(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );
  }

  function observe(btn) {
    if (observer) observer.observe(btn);
  }

  var initial = document.querySelector('[data-wr-loadmore]');
  if (initial) {
    initial.setAttribute('data-label', initial.textContent.trim());
    observe(initial);
  }
})();
